








































































































import {Component, Emit, Prop, PropSync, Vue} from 'vue-property-decorator'
import * as _ from 'lodash';

import {DxColorBox, DxScrollView} from "devextreme-vue";
import {DxCheckBox} from "devextreme-vue/check-box";
import AcceptService from "@/services/accept-service";
import AuthService from "@/services/auth_service";
import ArrayStore from "devextreme/data/array_store";
import {AcceptAggSchema} from "@/services/models-service";

@Component({
  name: 'AcceptGrid',
  components: {
    DxColorBox,
    DxScrollView,
    DxCheckBox,
  }
})
export default class extends Vue {

  @Prop() public dataSource: any;
  @Prop() public permissions: any;

  public service = AcceptService;

  public group_selected: any = {};

  public matrix_struct = {
    blocks__ok_hn__ok: -1, // 'ОК (С учетом хоз.нужд)',
    blocks__ok_hn__hn: -1, // 'Хоз.нужды',
    blocks__ok_hn__tp: -1, // 'Тех.потери',
    blocks__ok_hn__kp: -1, // 'Ком.потери',
    blocks__ok_hn__tso_p: -1, // 'Потери в смежный ТСО',

    blocks__purchase__volume: -1,
    blocks__purchase__tariff: -1,

    blocks__sale__volume: -1,
    blocks__sale__tariff: -1,

    blocks__transport_costs__volume: -1,
    blocks__transport_costs__tariff: -1,

    blocks__transport_income__volume: -1,
    blocks__transport_income__tariff: -1,

    blocks__fb02__tp: -1, // 'Тех.потери',
    blocks__fb02__kp: -1, // 'Ком.потери',
    blocks__fb02__tso_p: -1, // 'Потери в смежный ТСО',
    blocks__fb02__usefull: -1, // 'Полезный отпуск',
  };

  public columns_top: any[] = [
    {
      dataField: 'ok_hn',
      caption: 'ОК/ХН/Потери',
      width: '350px'
    },
    {
      dataField: 'purchase',
      caption: 'Покупка',
      width: '140px'
    },
    {
      dataField: 'sale',
      caption: 'Реализация',
      width: '140px'
    },
    {
      dataField: 'transport_costs',
      caption: 'Транспорт, затраты',
      width: '140px'
    },
    {
      dataField: 'transport_income',
      caption: 'Транспорт, выручка',
      width: '140px'
    },
    {
      dataField: 'fb02',
      caption: 'ФБ-02',
      width: '280px'
    },
  ];

  public columns_low: any[] = [
    {
      dataField: 'blocks__ok_hn__ok',
      caption: 'ОК (с учетом хоз. нужд)',
      dataType: 'number',
      format: 'number'
    },
    {
      dataField: 'blocks__ok_hn__hn',
      caption: 'Хоз. нужды',
      dataType: 'number',
      format: 'number'
    },
    {
      dataField: 'blocks__ok_hn__tp',
      caption: 'Тех. потери',
      dataType: 'number',
      format: 'number'
    },
    {
      dataField: 'blocks__ok_hn__kp',
      caption: 'Ком. потери',
      dataType: 'number',
      format: 'number'
    },
    {
      dataField: 'blocks__ok_hn__tso_p',
      caption: 'Потери в смежных ТСО',
      dataType: 'number',
      format: 'number'
    },
    {
      dataField: 'blocks__purchase__volume',
      caption: 'Объем',
      dataType: 'number',
      format: 'number'
    },
    {
      dataField: 'blocks__purchase__tariff',
      caption: 'Цена / Тариф',
      dataType: 'number',
      format: 'currency'
    },
    {
      dataField: 'blocks__sale__volume',
      caption: 'Объем',
      dataType: 'number',
      format: 'number'
    },
    {
      dataField: 'blocks__sale__tariff',
      caption: 'Цена / Тариф',
      dataType: 'number',
      format: 'currency'
    },
    {
      dataField: 'blocks__transport_costs__volume',
      caption: 'Объем',
      dataType: 'number',
      format: 'number'
    },
    {
      dataField: 'blocks__transport_costs__tariff',
      caption: 'Цена / Тариф',
      dataType: 'number',
      format: 'currency'
    },
    {
      dataField: 'blocks__transport_income__volume',
      caption: 'Объем',
      dataType: 'number',
      format: 'number'
    },
    {
      dataField: 'blocks__transport_income__tariff',
      caption: 'Цена / Тариф',
      dataType: 'number',
      format: 'currency'
    },
    {
      dataField: 'blocks__fb02__tp',
      caption: 'Тех. потери',
      dataType: 'number',
      format: 'number'
    },
    {
      dataField: 'blocks__fb02__kp',
      caption: 'Ком. потери',
      dataType: 'number',
      format: 'number'
    },
    {
      dataField: 'blocks__fb02__tso_p',
      caption: 'Потери в смежных ТСО',
      dataType: 'number',
      format: 'number'
    },
    {
      dataField: 'blocks__fb02__usefull',
      caption: 'Полезный отпуск',
      dataType: 'number',
      format: 'number'
    }
  ];

  get isAdmin() {
    return AuthService.isAdmin();
  }

  created() {

  }

  isSelectedBlock(val: any) {
    return val === true;
  }

  isMixedBlock(val: any) {
    return _.isNil(val);
  }

  isAllowed(node_id: string, block_name: string) {
    return this.permissions.hasOwnProperty(node_id) && this.permissions[node_id][block_name.replace('blocks__', 'accept__')]
  }

  forOperatorAllow(filial_id: string, node_id: string, object_id: any, block_name: string) {

    let current = this.dataSource[filial_id].nodes[node_id].objects.find((x: any) => {
      return x.id_object === object_id
    });

    if (!current) {
      console.error('Ошибка определения идентификатора строки');
      return false
    }

    return !this.isOperatorDenyDeaccept(current, block_name)
  }

  isOperatorDenyDeaccept(current: any, block_name: string) {
    return !this.isAdmin && current.blocks[`${block_name}_init`] === true
  }

  onColumnClick(dataFiled: string) {
    let set_value: boolean | null = null;
    if (this.group_selected.hasOwnProperty(dataFiled)) {
      set_value = !this.group_selected[dataFiled];
    } else {
      set_value = true;
    }
    this.group_selected[dataFiled] = set_value;

    for (let f_id of Object.keys(this.dataSource)) {
      for (let n_id of Object.keys(this.dataSource[f_id].nodes)) {
        if(!this.isAllowed(n_id, dataFiled)) {
          continue
        }
        for (let obj of this.dataSource[f_id].nodes[n_id].objects) {

          if (this.isOperatorDenyDeaccept(obj, dataFiled)) {
            continue
          }

          const curr_value = obj.blocks[dataFiled];
          let new_value: boolean | null = null;

          if (set_value === true) {
            if (curr_value === true) {
              continue

            } else {
              new_value = true;
            }

          } else {
            if (!this.isAdmin && _.isNil(obj.blocks[`${dataFiled}_init`])) {
              new_value = null;
            } else {
              new_value =  false;
            }
          }

          obj.blocks[dataFiled] = new_value;

          this.$forceUpdate();

          this.service.changed = true;


          if (this.service.changes.hasOwnProperty(obj.id_object)) {
            this.service.changes[obj.id_object][dataFiled] = new_value;
          } else {
            this.service.changes[obj.id_object] = {};
            this.service.changes[obj.id_object][dataFiled] = new_value;
          }
        }
      }
    }
  }

  onRowClick(obj: any, filial_id: string, node_id: string) {
    let set_value: boolean | null = null;
    if (this.group_selected.hasOwnProperty(`object_${obj.id_object}`)) {
      set_value = !this.group_selected[`object_${obj.id_object}`];
    } else {
      set_value = true;
    }

    this.group_selected[`object_${obj.id_object}`] = set_value;

    this.selectFullRow(obj, set_value, filial_id, node_id);
  }

  selectFullRow(obj: AcceptAggSchema, set_value: boolean, filial_id: string, node_id: string) {
    if (!obj || !obj.id_object) {
      return
    }

    for (let bl of Object.keys(this.matrix_struct)) {

      if(node_id) {
        if(!this.isAllowed(node_id, bl)) {
          continue
        }
      }
      if (this.isOperatorDenyDeaccept(obj, bl)) {
        continue
      }

      const curr_value = obj.blocks[bl];
      let new_value: boolean | null = null;

      if (set_value === true) {
        if (curr_value === true) {
          continue

        } else {
          new_value = true;
        }

      } else {
        if (!this.isAdmin && _.isNil(obj.blocks[`${bl}_init`])) {
          new_value = null;
        } else {
          new_value =  false;
        }
      }

      obj.blocks[bl] = new_value;

      this.$forceUpdate();

      this.service.changed = true;

      if (this.service.changes.hasOwnProperty(obj.id_object)) {
        this.service.changes[obj.id_object][bl] = new_value;
      } else {
        this.service.changes[obj.id_object] = {};
        this.service.changes[obj.id_object][bl] = new_value;
      }

      this.recalcTariffForNode(filial_id, node_id, obj.id_object, bl, new_value);
    }
  }

  onFilialRowClick(filial_id: string) {
    let set_value: boolean | null = null;
    if (this.group_selected.hasOwnProperty(`filial_${filial_id}`)) {
      set_value = !this.group_selected[`filial_${filial_id}`];
    } else {
      set_value = true;
    }
    this.group_selected[`filial_${filial_id}`] = set_value;

    for (let n_id of Object.keys(this.dataSource[filial_id].nodes)) {
      for (let obj of this.dataSource[filial_id].nodes[n_id].objects) {
        this.selectFullRow(obj, set_value, filial_id, n_id);
      }
    }
  }

  onNodeRowClick(filial_id: string, node_id: string) {
    let set_value: boolean | null = null;
    if (this.group_selected.hasOwnProperty(`heat_node_${node_id}`)) {
      set_value = !this.group_selected[`heat_node_${node_id}`];
    } else {
      set_value = true;
    }
    this.group_selected[`heat_node_${node_id}`] = set_value;

    for (let obj of this.dataSource[filial_id].nodes[node_id].objects) {
      this.selectFullRow(obj, set_value, filial_id, node_id);
    }

  }

  calcNewValue(init_value: boolean | null, curr_value: boolean | null) {
    let new_value: boolean | null = null;

    if (_.isNil(curr_value)) {
      new_value = true;
    }
    else if (curr_value === true) {

      if (!this.isAdmin && _.isNil(init_value)) {
        new_value = null;
      } else {
        new_value =  false;
      }
    }
    else if (curr_value === false) {
      if (_.isNil(init_value)) {
        new_value =  null;
      } else {
        new_value = true;
      }
    }

    return new_value
  }

  onCellClick(filial_id: string, node_id: string, object_id: any, block_name: string) {
    if(!this.isAllowed(node_id, block_name)) {
      return
    }

    let current = this.dataSource[filial_id].nodes[node_id].objects.find((x: any) => {
      return x.id_object === object_id
    });

    if (!current) {
      console.error('Ошибка определения идентификатора строки');
      return
    }
    // оператору запрещено снятие акцепта
    if (this.isOperatorDenyDeaccept(current, block_name)) {
      return
    }

    let new_value: boolean | null = this.calcNewValue(current.blocks[`${block_name}_init`], current.blocks[block_name]);
    current.blocks[block_name] = new_value;

    this.service.changed = true;

    if (this.service.changes.hasOwnProperty(object_id)) {
      this.service.changes[object_id][block_name] = new_value;
    } else {
      this.service.changes[object_id] = {};
      this.service.changes[object_id][block_name] = new_value;
    }
    this.recalcTariffForNode(filial_id, node_id, object_id, block_name, new_value);
    this.$forceUpdate();

  }

  recalcTariffForNode(filial_id: string, node_id: string, object_id: any, block_name: string, new_value: boolean | null) {
    if (block_name.indexOf('__tariff') !== -1) {
      // принудительная синхронизация значений тарифов для всех объектов теплового узла

      this.dataSource[filial_id].nodes[node_id].objects.forEach((o: any) => {
        if (o.id_object === object_id) {
          return
        }
        // оператор не может снимать акцепт
        if (this.isOperatorDenyDeaccept(o, block_name)) {
          return
        }

        if (!this.isAdmin && _.isNil(o.blocks[`${block_name}_init`]) && new_value === false) {
          o.blocks[block_name] = null;
          return;
        }

        if (!_.isNil(o.blocks[`${block_name}_init`]) && _.isNil(new_value)) {
          o.blocks[block_name] = false;
        } else {
          o.blocks[block_name] = new_value;
        }

        if (this.service.changes.hasOwnProperty(o.id_object)) {
          this.service.changes[o.id_object][block_name] = new_value;
        } else {
          this.service.changes[o.id_object] = {};
          this.service.changes[o.id_object][block_name] = new_value;
        }
      });
    }
  }


  private customizeCell(e: any) {
    if (e.rowType !== 'data' ||
      e.column.dataField.indexOf('blocks__') === -1) {
      return;
    }

    if (_.isNil(e.value)) {
      e.cellElement.classList.add('undefined');
      e.cellElement.innerHTML = '';
    }
    else if (e.value === true) {
      e.cellElement.classList.add('selected');
      e.cellElement.innerHTML = '';
    }
  }
}
